import { axios } from '@/utils/axios';

export type SecurityFactor = { id: number; type: 'email' | 'sms'; masked_destination: string; verified: boolean; requires_verification: boolean; is_default: boolean };
export type NotificationPreference = { category: string; channel: 'in_app' | 'email' | 'sms' | 'web_push'; enabled: boolean };
export type SecuritySettings = {
  factors: SecurityFactor[];
  wechat_linked: boolean;
  account_origin: 'legacy_email' | 'federated';
  external_identities: Array<{ provider: string; linked_at: string; last_authenticated_at: string | null; assurance_level: string | null }>;
  notification_preferences: NotificationPreference[];
};

export const getSecuritySettings = () => axios.get<{ success: boolean; data: SecuritySettings }>('/api/security-settings');
export const issueSecurityStepUp = (factorId: number, action: 'set_default_factor' | 'verify_phone' | 'unlink_wechat' | 'link_external', targetFactorId?: number) =>
  axios.post<{ success: boolean; data: { challenge_id: string } }>('/api/security-settings/step-up/issue', {
    factor_id: factorId,
    action,
    ...(targetFactorId ? { target_factor_id: targetFactorId } : {}),
  });
export const completeSecurityStepUp = (action: 'set_default_factor' | 'verify_phone' | 'unlink_wechat', challengeId: string, code: string) => {
  const routes = { set_default_factor: 'default-factor', verify_phone: 'phone/verify', unlink_wechat: 'wechat/unlink' };
  return axios.post(`/api/security-settings/${routes[action]}`, { challenge_id: challengeId, code });
};
export const updateNotificationPreference = (category: string, channel: string, enabled: boolean) =>
  axios.put('/api/security-settings/notification-preference', { category, channel, enabled });

export const issueFederatedContactVerification = (
  type: 'email' | 'sms',
  data: { email: string } | { country_code: '+852' | '+86'; phone: string }
) => axios.post<{ success: boolean; data: { challenge_id: string } }>(
  `/api/security-settings/contacts/${type}/issue`,
  data
);

export const verifyFederatedContact = (challengeId: string, code: string) =>
  axios.post('/api/security-settings/contacts/verify', { challenge_id: challengeId, code });

export const removeFederatedContact = (type: 'email' | 'sms', reauthIntentId: string) =>
  axios.delete(`/api/security-settings/contacts/${type}`, { data: { reauth_intent_id: reauthIntentId } });
